// src/Components/HelpCenter/HelpCenterData.ts
import AddPersonImage from 'src/Containers/HelpCenter/Images/add-person-management-team.png'
import EditPersonImage from 'src/Containers/HelpCenter/Images/edit-management-team-details.png'
import EditPersonStatusImage from 'src/Containers/HelpCenter/Images/edit-status-page.png'
import OrgChartImage from 'src/Containers/HelpCenter/Images/org-chart.png'
import AddUser from 'src/Containers/HelpCenter/Images/add-user.png'
import ViewOrgChart from 'src/Containers/HelpCenter/Images/view-org-chart.png'
import ViewOrgMngOrgChart from 'src/Containers/HelpCenter/Images/view-org-chart-mng-org-chart.png'
import TransferBody from 'src/Containers/HelpCenter/Images/transferbody.png'
import BodiesList from 'src/Containers/HelpCenter/Images/bodieslist.png'
import BodiesListCheckbox from 'src/Containers/HelpCenter/Images/bodieslistcheckbox.png'
import EditRegulationACIMatrix from 'src/Containers/HelpCenter/Images/edit-regulation-aci-matrix.png'
import ACIMatrixRegulation from 'src/Containers/HelpCenter/Images/aci-matrix-regulation-selection.png'

export const helpCenterData = [
    {
        module: 'Dashboard',
        topics: [
            {
                title: 'Dashboard',
                type: 'paragraph',
                content: [{ type: 'paragraph', text: 'A visual summary of data, metrics, and KPIs for tracking performance, risks, or compliance in real time.' }]
            },
            {
                title: 'History',
                type: 'paragraph',
                content: [{ type: 'paragraph', text: 'A record of past actions and decisions related to governance, risk, or compliance.' }]
            }
        ]
    },
    {
        module: 'Governance',
        topics: [
            {
                title: 'What is Governance in GRC?',
                type: 'rich_text',
                content: [
                    {
                        type: 'paragraph',
                        text: "In the context of Governance, Risk, and Compliance (GRC), 'governance' refers to the overall framework of rules, practices, and processes by which an organization is directed and controlled. It essentially defines:"
                    },
                    {
                        type: 'list',
                        format: 'unordered',
                        items: [
                            {
                                title: 'How decisions are made: ',
                                text: 'This includes establishing clear lines of authority and responsibility.',
                                bold: true
                            },
                            {
                                title: 'How objectives are set: ',
                                text: "Governance ensures that the organization's goals align with its values and strategic direction.",
                                bold: true
                            },
                            {
                                title: 'How performance is monitored: ',
                                text: 'It provides mechanisms for oversight and accountability.',
                                bold: true
                            }
                        ]
                    },
                    {
                        type: 'paragraph',
                        text: "Here's a breakdown of what governance entails within GRC:"
                    },
                    {
                        type: 'list',
                        format: 'unordered',
                        items: [
                            {
                                title: 'Establishing policies and procedures: ',
                                text: 'Creating the rules that guide organizational behavior.',
                                bold: true
                            },
                            {
                                title: 'Defining roles and responsibilities: ',
                                text: 'Clarifying who is accountable for what.',
                                bold: true
                            },
                            {
                                title: 'Setting strategic direction: ',
                                text: 'Aligning organizational activities with its mission and goals.',
                                bold: true
                            },
                            {
                                title: 'Ensuring accountability: ',
                                text: 'Holding individuals and teams responsible for their actions.',
                                bold: true
                            },
                            {
                                title: 'Promoting ethical conduct: ',
                                text: 'Fostering a culture of integrity and compliance.',
                                bold: true
                            }
                        ]
                    },
                    {
                        type: 'paragraph',
                        text: 'Essentially, governance in GRC provides the structure and framework that enables an organization to:'
                    },
                    {
                        type: 'list',
                        format: 'unordered',
                        items: [
                            {
                                text: 'Achieve its objectives.'
                            },
                            {
                                text: 'Manage risks effectively.'
                            },
                            {
                                text: 'Comply with relevant regulations.'
                            }
                        ]
                    },
                    {
                        type: 'paragraph',
                        text: "It's the 'G' that sets the stage for the 'R' (risk) and 'C' (compliance) to function effectively."
                    }
                ]
            },
            {
                title: 'What is Management Structure?',
                type: 'paragraph',
                content: [
                    {
                        type: 'paragraph',
                        text: 'The management structure, including management team, founders, and co-founders, requires comprehensive awareness of all GRC-related organizational decisions.'
                    }
                ]
            },
            {
                title: 'How to Create a Management Structure Profile?',
                type: 'rich_text',
                content: [
                    {
                        type: 'paragraph',
                        text: 'The term management structure refers to a single or group of management people in the organization.'
                    },
                    {
                        type: 'paragraph',
                        text: 'The management team details are created/added during the application onboarding process. You can simply fill in the details on the management team form to add the management team.'
                    }
                ]
            },
            {
                title: 'How to add another person to the Management team?',
                type: 'rich_text',
                content: [
                    {
                        type: 'paragraph',
                        text: "You can add another person details by clicking the '+' button in the top right corner of the Management Team section."
                    },
                    {
                        type: 'image',
                        url: AddPersonImage,
                        content: 'Form for adding a new member to the Management Team.'
                    }
                ]
            },
            {
                title: 'Can I add a management team member after onboarding is completed?',
                type: 'paragraph',
                content: [
                    {
                        type: 'paragraph',
                        text: "To add or manage the management structure post-onboarding, simply go to the 'Management Structure' submenu within the application."
                    }
                ]
            },
            {
                title: 'How to edit the management team details?',
                type: 'rich_text',
                content: [
                    {
                        type: 'paragraph',
                        text: 'Find the person you wish to edit, then click the edit icon positioned to the left of their name. This will allow you to update their details.'
                    },
                    {
                        type: 'image',
                        url: EditPersonImage,
                        content: 'Form for adding a new member to the Management Team.'
                    }
                ]
            },
            {
                title: 'What is the Status Active and Inactive field in the Management structure?',
                type: 'rich_text',
                content: [
                    {
                        type: 'paragraph',
                        text: "The 'Status' field (Active/Inactive) in the management structure allows for changing a person's status to 'Inactive' due to retirement, death, or other reasons such as illegal activities or conflicts of interest. An effective date and optional attachment can be provided. For reasons other than retirement or death, remarks are mandatory."
                    },
                    {
                        type: 'image',
                        url: EditPersonStatusImage,
                        content: 'Form for adding a new member to the Management Team.'
                    }
                ]
            },
            {
                title: 'How to Manage user roles and permissions for board members?',
                type: 'rich_text',
                content: []
            },
            {
                title: 'What is an organization chart?',
                type: 'rich_text',
                content: [
                    {
                        type: 'paragraph',
                        text: 'An organization chart (or org chart) in the GRC application is a diagram that visually represents the GRC structure of an organization. It shows:'
                    },
                    {
                        type: 'list',
                        format: 'unordered',
                        items: [
                            {
                                title: 'Reporting relationships: ',
                                text: 'Who reports to whom.',
                                bold: true
                            },
                            {
                                title: 'Hierarchical levels: ',
                                text: 'The levels of management and authority.',
                                bold: true
                            },
                            {
                                title: 'Departments and divisions: ',
                                text: 'The different functional areas within the organization.',
                                bold: true
                            },
                            {
                                title: 'Positions and roles: ',
                                text: 'The titles and responsibilities of individuals.',
                                bold: true
                            }
                        ]
                    },
                    {
                        type: 'paragraph',
                        text: 'In essence, it provides a clear picture of how an organization is organized and how its various parts connect.'
                    }
                ]
            },
            {
                title: 'How is the GRC Organization Chart different from a normal organization chart?',
                type: 'rich_text',
                content: [
                    {
                        type: 'paragraph',
                        text: 'The organization chart within this GRC application provides a visual representation of the organizational structure specifically related to governance, risk, and compliance workflows.'
                    },
                    {
                        type: 'table',
                        title: 'Comparison of Organization Charts',
                        sections: [
                            {
                                heading: 'Normal Organization Chart',
                                columns: [ 'Characteristic', 'Description' ],
                                rows: [
                                    [ 'Broad Scope', 'Depicts the overall structure of the entire organization, including all departments and roles.' ],
                                    [ 'General Purpose', 'Shows reporting relationships, hierarchies, and departmental divisions across the company.' ],
                                    [ 'Focus on Function', 'Emphasizes the functional organization of the business.' ],
                                    [ 'Wide Audience', 'Intended for all employees to understand the overall organizational structure.' ]
                                ]
                            },
                            {
                                heading: 'GRC Organization Chart',
                                columns: [ 'Characteristic', 'Description' ],
                                rows: [
                                    [ 'Narrower Scope', 'Focuses on individuals and teams involved in governance, risk, and compliance activities.' ],
                                    [ 'Specific Purpose', 'Highlights roles and responsibilities related to GRC processes such as Governance, regulatory compliance, risk management, and policy implementation.' ],
                                    [ 'Focus on Accountability', 'Emphasizes lines of accountability and responsibility within the GRC framework.' ],
                                    [ 'Targeted Audience', 'Used by GRC professionals, management, auditors, and regulatory bodies to understand the GRC structure and responsibilities.' ],
                                    [ 'Regulatory Mapping', 'Includes mappings of regulatory requirements to specific roles and responsibilities.' ],
                                    [ 'Control Focus', 'May show the relationship between personnel and internal controls.' ],
                                    [ 'Risk Ownership', 'Shows risk owners and their relationships to other departments.' ]
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                title: 'How to add a person to the org chart?',
                type: 'rich_text',
                content: [
                    {
                        type: 'paragraph',
                        text: "During onboarding, a sample org chart template is provided. Simply edit this template to create your organization's chart."
                    },
                    {
                        type: 'image',
                        url: OrgChartImage,
                        content: 'Sample organization chart template during onboarding.'
                    },
                    {
                        type: 'paragraph',
                        text: 'Fill all the required information and click on add button.'
                    },
                    {
                        type: 'image',
                        url: AddUser,
                        content: 'Form for adding a new person to the organization chart.'
                    },
                    {
                        type: 'paragraph',
                        text: 'Below is the sample visual representation of the org chart after you fill all the details.'
                    },
                    {
                        type: 'image',
                        url: ViewOrgChart,
                        content: 'Final representation of the organization chart with details filled.'
                    }
                ]
            },
            {
                title: 'What is the vacant checkbox in the org chart?',
                type: 'rich_text',
                content: [
                    {
                        type: 'heading',
                        level: 2,
                        text: 'Managing Vacant Positions in the Org Chart'
                    },
                    {
                        type: 'heading',
                        level: 3,
                        text: 'Purpose:'
                    },
                    {
                        type: 'paragraph',
                        text: "The 'Vacant' checkbox in the Organization Chart allows you to accurately reflect positions that are currently unfilled. This is crucial for maintaining an up-to-date representation of your organization's structure, particularly for GRC-related roles."
                    },
                    {
                        type: 'heading',
                        level: 3,
                        text: 'When to Use the Vacant Checkbox:'
                    },
                    {
                        type: 'list',
                        format: 'ordered',
                        items: [
                            {
                                title: 'Initial Org Chart Creation:',
                                sub_items: [
                                    {
                                        text: "If a position exists within your organization's structure but is not currently occupied by a person during the initial org chart setup, select the 'Vacant' checkbox."
                                    }
                                ]
                            },
                            {
                                title: 'Personnel Departures:',
                                sub_items: [
                                    {
                                        text: 'When an employee leaves the organization due to retirement, suspension, or any other reason, and their position remains vacant, follow these steps:'
                                    },
                                    {
                                        type: 'list',
                                        format: 'unordered',
                                        items: [
                                            { text: "Enter an 'Effective End Date' for the departing employee." },
                                            { text: "Click the 'Vacant' checkbox." },
                                            { text: 'This will visually indicate the vacancy in the Org Chart, serving as an alert to the management team.' }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        type: 'heading',
                        level: 3,
                        text: "Mandatory Steps Before Selecting 'Vacant'"
                    },
                    {
                        type: 'heading',
                        level: 4,
                        text: 'Task Reassignment:'
                    },
                    {
                        type: 'list',
                        format: 'unordered',
                        items: [
                            { text: 'Before marking a position as vacant, ensure all tasks associated with the departing employee are reassigned to another active employee.' },
                            { text: 'This is critical to prevent tasks from being overlooked or delayed.' },
                            { text: 'Note: Tasks cannot be assigned to a vacant position.' }
                        ]
                    },
                    {
                        type: 'heading',
                        level: 4,
                        text: 'Filling a Vacant Position:'
                    },
                    {
                        type: 'list',
                        format: 'unordered',
                        items: [
                            { text: 'Once a new employee fills the vacant position:' },
                            {
                                type: 'list',
                                format: 'unordered',
                                sub_items: [
                                    { text: "Remove the 'Vacant' checkbox." },
                                    { text: "Enter an 'End Date' for the vacancy period." },
                                    { text: 'Map the new employee to the position.' }
                                ]
                            }
                        ]
                    },
                    {
                        type: 'heading',
                        level: 3,
                        text: 'Key Considerations:'
                    },
                    {
                        type: 'list',
                        format: 'unordered',
                        items: [
                            { title: 'Alerting Management: ', text: " The 'Vacant' checkbox serves as a visual alert to management, highlighting areas requiring attention." },
                            { title: 'Task Continuity: ', text: 'Task Continuity: Reassigning tasks before marking a position vacant ensures uninterrupted workflow.' },
                            { title: 'Accurate Records: ', text: 'Accurate Records: Maintaining accurate records of vacancy periods is essential for organizational planning and reporting.' }
                        ]
                    },
                    {
                        type: 'heading',
                        level: 3,
                        text: 'Example Scenario:'
                    },
                    {
                        type: 'paragraph',
                        text: 'John Doe, a Compliance Officer, retires on December 31, 2024. Before marking his position as vacant:'
                    },
                    {
                        type: 'list',
                        format: 'ordered',
                        items: [
                            { text: 'All compliance tasks assigned to John Doe are reassigned to Jane Smith.' },
                            { text: "John Doe's profile is updated with an 'Effective End Date' of December 31, 2024." },
                            { text: "The 'Vacant' checkbox is selected for his position." }
                        ]
                    },
                    {
                        type: 'paragraph',
                        text: 'When a new Compliance Officer, Alex Lee, is hired on January 15, 2025:'
                    },
                    {
                        type: 'list',
                        format: 'ordered',
                        items: [
                            { text: "The 'Vacant' checkbox is deselected." },
                            { text: "An 'End Date' of January 14, 2025, is entered for the vacancy." },
                            { text: 'Alex Lee is mapped to the Compliance Officer position.' }
                        ]
                    }
                ]
            },
            {
                title: 'How do I edit person information in the Org Chart?',
                type: 'paragraph',
                content: [
                    {
                        type: 'paragraph',
                        text: "Click the three-dot icon (ellipsis) located in the top left of the person's information card, and then select the 'Edit' icon to modify their details."
                    }
                ]
            },
            {
                title: 'What is the Difference between View Org chart and Manage Org chart?',
                type: 'paragraph',
                content: [
                    {
                        type: 'paragraph',
                        text: "If you have 'View Org Chart' access, you can see the organization chart. To edit, update, or reassign regulations, you'll need 'Manage Org Chart' access."
                    },
                    {
                        type: 'image',
                        url: ViewOrgMngOrgChart,
                        content: 'Sample organization chart template during onboarding.'
                    }
                ]
            },
            {
                title: 'What is Review & Reassign in the Org chart?',
                type: 'paragraph',
                content: [
                    {
                        type: 'paragraph',
                        text: "Use the 'Review & Reassign' feature in the Org Chart to manage governance by transferring regulation ownership, specifically the Accountable, Consulted, and Informed roles, between personnel due to leaves or organizational changes."
                    },
                    {
                        type: 'image',
                        url: TransferBody,
                        content: 'Sample organization chart template during onboarding.'
                    }
                ]
            },
            {
                title: 'What is the Regulation list?',
                type: 'rich_text',
                content: [
                    {
                        type: 'paragraph',
                        text: 'A Regulation List is a comprehensive inventory of the regulatory and statutory bodies and/or the specific regulations and laws that an organization is required to comply with. It serves as a central point of reference for:'
                    },
                    {
                        type: 'list',
                        format: 'unordered',
                        items: [
                            {
                                title: 'Identifying applicable regulations',
                                text: '',
                                bold: true
                            },
                            {
                                title: 'Tracking compliance obligations',
                                text: '',
                                bold: true
                            },
                            {
                                title: 'Managing regulatory changes',
                                text: '',
                                bold: true
                            },
                            {
                                title: 'Demonstrating compliance',
                                text: '',
                                bold: true
                            }
                        ]
                    },
                    {
                        type: 'paragraph',
                        text: 'From the regulation list, choose the regulatory and statutory bodies that apply to your compliance obligations.'
                    },
                    {
                        type: 'image',
                        url: BodiesList,
                        content: 'Sample organization chart template during onboarding.'
                    },
                    {
                        type: 'image',
                        url: BodiesListCheckbox,
                        content: 'Sample organization chart template during onboarding.'
                    }
                ]
            },
            {
                title: 'What is the ACI Matrix in Regulation selection?',
                type: 'rich_text',
                content: [
                    {
                        type: 'paragraph',
                        text: "In this RACI matrix, regulations are assigned roles for Accountable, Consulted, and Informed parties. The 'Responsible' role is intentionally omitted for regulations, as the regulation itself is an external requirement, not an internal task to be 'done.' Instead, we focus on who is:"
                    },
                    {
                        type: 'list',
                        format: 'unordered',
                        items: [
                            {
                                title: 'Accountable:',
                                text: "The person ultimately responsible for ensuring the organization's compliance with the regulation.",
                                bold: true
                            },
                            {
                                title: 'Consulted:',
                                text: 'The individuals or groups whose expertise or input is required regarding the regulation.',
                                bold: true
                            },
                            {
                                title: 'Informed:',
                                text: 'The individuals or groups who need to be kept up-to-date on matters related to the regulation.',
                                bold: true
                            }
                        ]
                    },
                    {
                        type: 'paragraph',
                        text: 'Use the assignment fields to designate the appropriate personnel for each of these roles.'
                    },
                    {
                        type: 'image',
                        url: ACIMatrixRegulation,
                        content: 'Sample organization chart template during onboarding.'
                    }
                ]
            },
            {
                title: 'How to Edit the Regulation ACI Matrix details?',
                type: 'paragraph',
                content: [
                    {
                        type: 'paragraph',
                        text: 'Find the Regulation you wanted to edit, then click the edit icon positioned to the left of their Regulation. This will allow you to update the ACI matrix details.'
                    },
                    {
                        type: 'image',
                        url: EditRegulationACIMatrix,
                        content: 'Sample organization chart template during onboarding.'
                    }
                ]
            }
        ]
    },
    {
        module: 'Risk',
        topics: [
            {
                title: 'What is Risk in GRC',
                type: 'rich_text',
                content: [
                    {
                        type: 'paragraph',
                        text: "In the context of Governance, Risk, and Compliance (GRC), 'risk' refers to the potential for events or circumstances to negatively impact an organization's objectives. These impacts can be financial, operational, legal, reputational, or strategic."
                    },
                    {
                        type: 'heading',
                        level: 3,
                        text: "Here's a breakdown:"
                    },
                    {
                        type: 'list',
                        format: 'unordered',
                        items: [
                            { title: 'Potential for Negative Impact: ', text: "Risk involves the possibility of something going wrong. It's not a certainty, but a probability." },
                            { title: 'Impact on Objectives: ', text: "Risks are assessed based on how they might hinder an organization's ability to achieve its goals." },
                            { title: 'Accurate Records: ', text: 'Accurate Records: Maintaining accurate records of vacancy periods is essential for organizational planning and reporting.' },
                            {
                                title: 'Types of Risks:',
                                sub_items: [
                                    { title: 'Financial Risks: ', text: 'Related to monetary losses, such as market fluctuations or fraud.' },
                                    { title: 'Operational Risks: ', text: 'Pertaining to disruptions in business processes, like supply chain issues or system failures.' },
                                    { title: 'Legal Risks: ', text: 'Involving potential violations of laws and regulations.' },
                                    { title: 'Reputational Risks: ', text: "Affecting the organization's public image and brand." },
                                    { title: 'Strategic Risks: ', text: 'Related to decisions that could impact the long-term direction of the organization.' }
                                ]
                            }
                        ]
                    },
                    {
                        type: 'list',
                        format: 'unordered',
                        items: [
                            { title: "GRC's Role: ", text: 'GRC frameworks help organizations identify, assess, manage, and monitor these risks to minimize their potential impact. This involves establishing policies, procedures, and controls to mitigate risks and ensure compliance.' }
                        ]
                    }
                ]
            },
            {
                title: 'What is the difference between the Raised and Owned risk?',
                type: 'rich_text',
                content: [
                    {
                        type: 'heading',
                        level: 3,
                        text: 'Raised vs. Owned Risks: '
                    },
                    {
                        type: 'list',
                        format: 'unordered',
                        items: [
                            {
                                title: 'Raised Risks: ',
                                sub_items: [
                                    { text: 'These are risks that department members have identified and recorded within the system .' },
                                    { text: "The 'Raised Risks' tab exclusively displays the risks that have been raised by department within the user's own department." }
                                ]
                            },
                            {
                                title: 'Owned Risks: ',
                                sub_items: [
                                    { text: 'These risks are assigned to the department, and they are responsible for their mitigation.' },
                                    { text: "The 'Owned Risks' tab presents risks that have been raised against the department, irrespective of the initial raiser, and for which they bear the responsibility of addressing." }
                                ]
                            },
                            {
                                title: 'All Risks: ',
                                sub_items: [
                                    { text: 'This tab provides a comprehensive view of all risks within the system, including both those that the user or their department has raised and those that have been assigned to them.' }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                title: 'How to register a Risk?',
                type: 'rich_text',
                content: [
                    {
                        type: 'paragraph',
                        text: 'To register a new risk, follow the below steps'
                    },
                    {
                        type: 'list',
                        format: 'ordered',
                        items: [
                            { text: "Navigate to the 'Risk' menu," },
                            { text: "select 'Risk Register,' and" },
                            { text: "click the 'Add Risk' button." }
                        ]
                    },
                    {
                        type: 'paragraph',
                        text: "Upon clicking 'Add Risk,' the risk registration page will open. Fill in the Risk Summary Details, Risk Scoring, and Suggested Mitigation sections. Then, click 'Save' to create a new risk in the Risk Register."
                    }
                ]
            },
            {
                title: 'What is a Heat Map in a Risk Module?',
                type: 'rich_text',
                content: [
                    {
                        type: 'list',
                        format: 'unordered',
                        items: [
                            {
                                title: 'Visual Risk Assessment:',
                                sub_items: [
                                    { text: 'A heat map in a Risk Module is a matrix or grid where one axis represents the probability or likelihood of a risk occurring, and the other axis represents the potential impact or consequence of that risk.' },
                                    { text: 'The cells within the matrix are color-coded to indicate the overall severity or priority of each risk.' }
                                ]
                            },
                            {
                                title: 'Risk Prioritization:',
                                sub_items: [
                                    { text: 'It provides a clear visual representation of risk levels, making it easy to identify high-priority risks that require immediate attention.' },
                                    { text: 'Typically, "red" areas indicate high-risk, "yellow/orange" areas indicate medium-risk, and "green" areas indicate low-risk.' }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                title: 'How to Use a 5x5 Heat Map?',
                type: 'rich_text',
                content: [
                    {
                        type: 'heading',
                        level: 3,
                        text: 'Risk Assessment: '
                    },
                    {
                        type: 'paragraph',
                        text: "Assess each identified risk and assign it a probability and impact level based on your organization's criteria. "
                    },
                    {
                        type: 'heading',
                        level: 3,
                        text: 'Mapping: '
                    },
                    {
                        type: 'paragraph',
                        text: 'Plot each risk on the heat map by finding the cell that corresponds to its probability and impact levels. '
                    },
                    {
                        type: 'heading',
                        level: 3,
                        text: 'Interpretation: '
                    },
                    {
                        type: 'list',
                        format: 'unordered',
                        items: [
                            {
                                title: 'Red Zone (Extreme): ',
                                sub_items: [
                                    { text: 'Risks in the red zone require immediate attention and mitigation strategies.' },
                                    { text: 'These risks have a high likelihood of occurring and a significant impact.' }
                                ]
                            },
                            {
                                title: 'Orange Zone (High Risk): ',
                                sub_items: [
                                    { text: 'Risks in the orange zone should be monitored and mitigated as necessary.' },
                                    { text: 'These risks have a High likelihood or impact.' }
                                ]
                            },
                            {
                                title: 'Yellow (Medium Risk): ',
                                sub_items: [
                                    { text: 'Risks in the yellow zone should be monitored and mitigated as necessary. ' },
                                    { text: 'These risks have a moderate likelihood or impact. ' }
                                ]
                            },
                            {
                                title: 'Green Zone (Low Risk): ',
                                sub_items: [
                                    { text: 'Risks in the green zone have a low likelihood and impact.' },
                                    { text: 'These risks may require minimal monitoring.' }
                                ]
                            },
                            {
                                title: 'Blue Zone (Controlled Risk):',
                                sub_items: [
                                    { text: 'Risks in the Blue zone have a Controlled likelihood and impact.' },
                                    { text: 'These risks may require minimal or no monitoring.' }
                                ]
                            }
                        ]
                    },
                    {
                        type: 'heading',
                        level: 3,
                        text: 'Prioritization: '
                    },
                    {
                        type: 'list',
                        format: 'unordered',
                        items: [
                            { text: 'Use the heat map to prioritize risk mitigation efforts. ' },
                            { text: 'Focus on addressing the risks in the red zone first, followed by those in the yellow/orange zone. ' }
                        ]
                    },
                    {
                        type: 'heading',
                        level: 3,
                        text: 'Monitoring: '
                    },
                    {
                        type: 'list',
                        format: 'unordered',
                        items: [
                            { text: 'Regularly update the heat map as risk levels change.' },
                            { text: 'Monitor the effectiveness of mitigation strategies and adjust them as needed.' }
                        ]
                    }
                ]
            },
            {
                title: 'what is suggested mitigation? ',
                type: 'rich_text',
                content: [
                    {
                        type: 'paragraph',
                        text: "Suggested mitigation refers to the proposed actions or strategies recommended to reduce or eliminate the negative impact of an identified risk. It's about outlining how to lessen the likelihood of a risk occurring or minimize its consequences if it does."
                    },
                    {
                        type: 'paragraph',
                        text: "Here's a breakdown: "
                    },
                    {
                        type: 'heading',
                        level: 3,
                        text: 'Risk Reduction: '
                    },
                    {
                        type: 'list',
                        format: 'unordered',
                        items: [
                            { text: 'Mitigation aims to lower the probability or impact of a risk, or both.' }
                        ]
                    },
                    {
                        type: 'heading',
                        level: 3,
                        text: 'Actionable Strategies: '
                    },
                    {
                        type: 'list',
                        format: 'unordered',
                        items: [
                            { text: 'Suggested mitigations are concrete, actionable steps that can be taken.' }
                        ]
                    },
                    {
                        type: 'heading',
                        level: 3,
                        text: 'Proactive Approach: '
                    },
                    {
                        type: 'list',
                        format: 'unordered',
                        items: [
                            { text: "It's a proactive approach to risk management, rather than a reactive one." }
                        ]
                    },
                    {
                        type: 'heading',
                        level: 3,
                        text: 'Examples: '
                    },
                    {
                        type: 'list',
                        format: 'unordered',
                        items: [
                            { text: 'If a risk is "data breach," suggested mitigations might include:' },
                            {
                                sub_items: [
                                    { text: 'Implementing stronger password policies.' },
                                    { text: 'Encrypting sensitive data.' },
                                    { text: 'Conducting regular security audits.' },
                                    { text: 'Training employees on cybersecurity best practices.' }
                                ]
                            },
                            { text: 'If a risk is "supply chain disruption" suggested mitigations might include:' },
                            {
                                sub_items: [
                                    { text: 'Diversifying suppliers.' },
                                    { text: 'Increasing inventory.' },
                                    { text: 'Creating contingency plans.' }
                                ]
                            }
                        ]
                    },
                    {
                        type: 'heading',
                        level: 3,
                        text: 'Risk Management Process: '
                    },
                    {
                        type: 'list',
                        format: 'unordered',
                        items: [
                            { text: 'Suggested mitigations are a key part of the risk management process, following risk identification and assessment.' },
                            { text: 'It is the "What are we going to do about this risk?" portion of the process.' }
                        ]
                    },
                    {
                        type: 'paragraph',
                        text: 'In essence, suggested mitigation is the plan of action to address and manage identified risks.'
                    }
                ]
            },
            {
                title: 'What are the stages in the risk register?',
                type: 'rich_text',
                content: [
                    {
                        type: 'paragraph',
                        text: "Here's a breakdown of each stage"
                    },
                    {
                        type: 'list',
                        format: 'ordered',
                        items: [
                            { text: 'Initiate & Acknowledge' },
                            { text: 'Approval In progress' },
                            { text: 'Mitigate & Monitor' },
                            { text: 'Close' },
                            { text: 'History' }
                        ]
                    },
                    {
                        type: 'heading',
                        level: 3,
                        text: '1. Initiate & Acknowledge: '
                    },
                    {
                        type: 'list',
                        format: 'unordered',
                        items: [
                            {
                                title: 'Description: ',
                                sub_items: [
                                    { text: 'This stage represents the initial registration of a new risk.' },
                                    { text: 'The newly created risk entry appears in this stage.' },
                                    { text: 'The department head of the department that raised the risk is required to acknowledge the risk (L1 acknowledgement).' },
                                    { text: 'Upon acknowledgement by the department head, the risk progresses to the "Approval in Progress" stage.' }
                                ]
                            }
                        ]
                    },
                    {
                        type: 'heading',
                        level: 3,
                        text: '2. Approval in Progress: '
                    },
                    {
                        type: 'list',
                        format: 'unordered',
                        items: [
                            {
                                title: 'Description: ',
                                sub_items: [
                                    { text: 'In this stage, the risk awaits approval from the manager who owns the risk (L2 approval).' },
                                    { text: 'Once the owned manager approves the risk, it transitions to the "Mitigate & Monitor" stage.' }
                                ]
                            }
                        ]
                    },
                    {
                        type: 'heading',
                        level: 3,
                        text: '3. Mitigate & Monitor: '
                    },
                    {
                        type: 'list',
                        format: 'unordered',
                        items: [
                            {
                                title: 'Description: ',
                                sub_items: [
                                    { text: 'This stage is for risks that require further assessment and mitigation.' },
                                    { text: 'It includes risks undergoing qualitative and quantitative risk assessments.' },
                                    { text: 'Mitigation plans and task lists are created and completed in this stage.' }
                                ]
                            }
                        ]
                    },
                    {
                        type: 'heading',
                        level: 3,
                        text: '4. Close: '
                    },
                    {
                        type: 'list',
                        format: 'unordered',
                        items: [
                            {
                                title: 'Description: ',
                                sub_items: [
                                    { text: 'This stage contains risks with open tasks.' },
                                    { text: 'Once all tasks associated with the risk are marked as "completed," the risk is closed and the closed risk will be moved to the "History" stage.' }
                                ]
                            }
                        ]
                    },
                    {
                        type: 'heading',
                        level: 3,
                        text: '5. History: '
                    },
                    {
                        type: 'list',
                        format: 'unordered',
                        items: [
                            {
                                title: 'Description: ',
                                sub_items: [
                                    { text: 'This stage contains all the closed risk which includes.' },
                                    { text: 'Completed and closed.' },
                                    { text: 'Rejected and closed.' }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                title: 'What is Opportunity Risk?',
                type: 'rich_text',
                content: [
                    {
                        type: 'paragraph',
                        text: "Opportunity risk, refers to the potential for missed or unrealized gains due to inaction or poor decision-making. It's the risk of not taking advantage of a favorable situation or failing to capitalize on a potential benefit."
                    },
                    {
                        type: 'list',
                        format: 'unordered',
                        items: [
                            {
                                title: 'Focus on Potential Gain: ',
                                sub_items: [
                                    { text: 'Unlike traditional risks that focus on negative outcomes, opportunity risks highlight the potential for positive outcomes that are lost.' }
                                ]
                            }
                        ]
                    },
                    {
                        type: 'list',
                        format: 'unordered',
                        items: [
                            {
                                title: 'Inaction or Poor Decisions: ',
                                sub_items: [
                                    { text: 'Opportunity risks arise from failing to recognize or act on opportunities, or from making decisions that prevent the realization of those opportunities.' }
                                ]
                            }
                        ]
                    },
                    {
                        type: 'list',
                        format: 'unordered',
                        items: [
                            {
                                title: 'Examples: ',
                                sub_items: [
                                    { text: 'Failing to enter a new market with high growth potential.' },
                                    { text: 'Not investing in new technologies that could improve efficiency or create new revenue streams.' },
                                    { text: 'Missing out on partnerships or collaborations that could lead to competitive advantages.' },
                                    { text: 'Ignoring customer feedback that could lead to product improvements.' }
                                ]
                            }
                        ]
                    },
                    {
                        type: 'list',
                        format: 'unordered',
                        items: [
                            {
                                title: 'GRC Context: ',
                                sub_items: [
                                    { text: "While GRC traditionally focuses on mitigating negative risks, it's also important to consider opportunity risks." },
                                    { text: 'Effective GRC frameworks should help organizations identify and evaluate potential opportunities, and make informed decisions about whether to pursue them.' },
                                    { text: 'This is often done by having good strategic planning, and good lines of communications.' }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                title: 'How many levels are there in the risk approval process?',
                type: 'rich_text',
                content: [
                    {
                        type: 'heading',
                        level: 3,
                        text: 'Risk Approval Process: L1 Acknowledgement and L2 Approval'
                    },
                    {
                        type: 'heading',
                        level: 3,
                        text: 'Introduction: '
                    },
                    {
                        type: 'paragraph',
                        text: 'The risk approval process in our system involves two distinct levels, L1 and L2, to ensure thorough review and appropriate action on identified risks. While both levels participate in the review, their roles and authorities differ significantly.'
                    },
                    {
                        type: 'heading',
                        level: 3,
                        text: 'L1 Acknowledgement: '
                    },
                    {
                        type: 'list',
                        format: 'unordered',
                        items: [
                            {
                                title: 'Purpose: ',
                                sub_items: [
                                    { text: 'The L1 approval is designated as an "Acknowledgement" step.' },
                                    { text: 'It serves to confirm that the initial risk assessment has been reviewed by the relevant department head.' }
                                ]
                            },
                            {
                                title: 'Actions: ',
                                sub_items: [
                                    { text: 'The L1 approver (Raised department head) has two options:' },
                                    { title: 'Acknowledge:', text: 'It serves to confirm that the initial risk assessment has been reviewed by the relevant department head.' },
                                    { title: 'Deny:', text: "This effectively stops the risk's progression, indicating that the risk is not considered valid or requires significant revision." }
                                ]
                            },
                            {
                                title: 'Key Point: ',
                                sub_items: [
                                    { text: "The L1 Acknowledgement primarily focuses on the initial review and validation of the risk's relevance." }
                                ]
                            }
                        ]
                    },
                    {
                        type: 'heading',
                        level: 3,
                        text: 'L2 Approval: '
                    },
                    {
                        type: 'list',
                        format: 'unordered',
                        items: [
                            {
                                title: 'Purpose: ',
                                sub_items: [
                                    { text: 'The L2 approval is a formal approval step.' },
                                    { text: 'It signifies that the risk has been thoroughly evaluated and is approved for mitigation or further action.' }
                                ]
                            },
                            {
                                title: 'Actions: ',
                                sub_items: [
                                    { text: 'The L2 approver (owned manager) has the authority to:' },
                                    { title: 'Reject:', text: "This stops the risk's further advancement. This action is used when the L2 approver determines that the risk is not acceptable or requires substantial changes." }
                                ]
                            },
                            {
                                title: 'Key Point: ',
                                sub_items: [
                                    { text: 'The L2 Approval represents a higher level of authorization and carries the power to prevent the risk from moving forward.' }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                title: 'What is the difference between the Qualitative risk assessment vs Quantitative risk assessment?',
                type: 'rich_text',
                content: [
                    {
                        type: 'heading',
                        level: 3,
                        text: 'Qualitative Risk Assessment:'
                    },
                    {
                        type: 'list',
                        format: 'unordered',
                        items: [
                            {
                                title: 'Focus: ',
                                sub_items: [
                                    { text: 'Subjective assessment based on expert judgment, experience, and opinions.' },
                                    { text: 'Focuses on the characteristics of risks, rather than numerical values.' }
                                ]
                            },
                            {
                                title: 'Methodology: ',
                                sub_items: [
                                    { text: 'Uses descriptive scales (e.g., low, medium, high) to assess probability and impact.' }
                                ]
                            },
                            {
                                title: 'Outputs: ',
                                sub_items: [
                                    { text: 'Risk matrices or heat maps that visually represent risk priorities.' }
                                ]
                            },
                            {
                                title: 'Advantages: ',
                                sub_items: [
                                    { text: 'Relatively quick and easy to perform.' },
                                    { text: 'Useful for identifying and prioritizing a wide range of risks.' },
                                    { text: 'Facilitates communication and discussion about risks.' }
                                ]
                            },
                            {
                                title: 'Disadvantages: ',
                                sub_items: [
                                    { text: 'Subjective and prone to bias.' },
                                    { text: 'Provides limited precision and accuracy.' },
                                    { text: 'Difficult to compare risks consistently.' }
                                ]
                            }
                        ]
                    },
                    {
                        type: 'heading',
                        level: 3,
                        text: 'Quantitative Risk Assessment: '
                    },
                    {
                        type: 'list',
                        format: 'unordered',
                        items: [
                            {
                                title: 'Focus: ',
                                sub_items: [
                                    { text: 'Objective assessment based on numerical data and statistical analysis.' },
                                    { text: 'Focuses on the magnitude of risks, expressed in monetary or other quantifiable terms.' }
                                ]
                            },
                            {
                                title: 'Methodology: ',
                                sub_items: [
                                    { text: 'Uses statistical techniques (e.g., Monte Carlo simulation, probability distributions) to calculate risk probabilities and impacts.' },
                                    { text: 'Relies on historical data, mathematical models, and statistical analysis.' },
                                    { text: 'Uses numerical data.' }

                                ]
                            },
                            {
                                title: 'Outputs: ',
                                sub_items: [
                                    { text: 'Probability distributions of potential losses.' },
                                    { text: 'Expected monetary value (EMV) of risks. ' },
                                    { text: 'Sensitivity analysis and scenario analysis.' },
                                    { text: 'Numerical values for risk probability and impact. ' }
                                ]
                            },
                            {
                                title: 'Advantages: ',
                                sub_items: [
                                    { text: 'Provides objective and precise risk estimates.' },
                                    { text: 'Facilitates cost-benefit analysis of risk mitigation strategies.' },
                                    { text: 'Enables consistent comparison of risks.' }
                                ]
                            },
                            {
                                title: 'Disadvantages: ',
                                sub_items: [
                                    { text: 'Requires significant data and expertise.' },
                                    { text: 'Can be time-consuming and expensive.' },
                                    { text: 'May be difficult to apply to all types of risks.' }

                                ]
                            },
                            {
                                title: 'Key Differences Summarized: ',
                                sub_items: [
                                    { title: 'Subjectivity vs. Objectivity: ', text: 'Qualitative is subjective, quantitative is objective.' },
                                    { title: 'Data: ', text: 'Qualitative uses descriptive data, quantitative uses numerical data.' },
                                    { title: 'Output: ', text: 'Qualitative produces descriptive prioritizations, quantitative produces numerical risk values.' },
                                    { title: 'Complexity: ', text: 'Qualitative is simpler, quantitative is more complex.' }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                title: 'What is Risk Dispute Process?',
                type: 'rich_text',
                content: [
                    {
                        type: 'paragraph',
                        text: "A risk dispute arises when the L2 manager of the owned department rejects a risk that was initially raised by another department (L1). This signifies a disagreement on the risk's validity or the proposed mitigation strategies."
                    },
                    {
                        type: 'heading',
                        level: 3,
                        text: 'Process:'
                    },
                    {
                        type: 'heading',
                        level: 3,
                        text: '1. L2 Rejection:'
                    },
                    {
                        type: 'list',
                        format: 'unordered',
                        items: [
                            { text: 'If the L2 manager of the owned department rejects a risk, the L1 manager of the department that raised the risk has the option to initiate a dispute.' }
                        ]
                    },
                    {
                        type: 'heading',
                        level: 3,
                        text: '2. Dispute Initiation:'
                    },
                    {
                        type: 'list',
                        format: 'unordered',
                        items: [
                            { text: "The L1 manager initiates the dispute, indicating their disagreement with the L2 manager's rejection." }
                        ]
                    },
                    {
                        type: 'heading',
                        level: 3,
                        text: '3. Meeting/Discussion:'
                    },
                    {
                        type: 'list',
                        format: 'unordered',
                        items: [
                            { text: 'A meeting or discussion is scheduled between the L1 manager, the L2 manager, and any other relevant stakeholders.' },
                            { text: 'The purpose of this meeting is to: ' },
                            {
                                sub_items: [
                                    { text: 'Review the risk assessment and rationale for rejection.' },
                                    { text: 'Discuss and attempt to resolve the disagreement.' },
                                    { text: "Reach a consensus on the risk's disposition." }
                                ]
                            }
                        ]
                    },
                    {
                        type: 'heading',
                        level: 3,
                        text: '4. Resolution Outcomes:'
                    },
                    {
                        type: 'list',
                        format: 'unordered',
                        items: [
                            {
                                title: 'Agreement and Approval:',
                                sub_items: [
                                    { text: 'If the managers agree and the risk is approved, the risk progresses to the "Mitigate and Monitor" stage for further processing.' }
                                ]
                            },
                            {
                                title: 'Continued Rejection: ',
                                sub_items: [
                                    { text: 'If the disagreement persists, and the risk remains rejected, it is moved to the "History" stage.' }
                                ]
                            },
                            {
                                title: 'Purpose: ',
                                sub_items: [
                                    { text: 'This dispute process ensures that risk assessments are thoroughly reviewed and that disagreements are addressed through collaborative discussions, promoting a fair and consistent risk management approach.' }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        module: 'Compliance',
        topics: [
            {
                title: 'What is compliance in the GRC application?',
                type: 'rich_text',
                content: [
                    {
                        type: 'paragraph',
                        text: 'Compliance refers to the processes and activities undertaken to ensure an organization adheres to Mandate by Law and Mandate by Board.'
                    },
                    {
                        type: 'heading',
                        level: 3,
                        text: 'Mandate by Law:'
                    },
                    {
                        type: 'list',
                        format: 'unordered',
                        items: [
                            { title: 'Laws and Regulations: ', text: 'These are legal requirements mandated by government bodies, such as industry-specific regulations, data privacy laws, or financial reporting standards.' }
                        ]

                    },
                    {
                        type: 'heading',
                        level: 3,
                        text: 'Mandate by Board:'
                    },
                    {
                        type: 'list',
                        format: 'unordered',
                        items: [

                            { title: 'Internal Policies and Procedures (Mandate by Board): ', text: "These are the organization's own rules and guidelines, designed to maintain ethical conduct, operational efficiency, and risk mitigation." },
                            { title: 'Industry Standards: ', text: 'These are best practices and guidelines developed by industry associations or recognized bodies.' },
                            { title: 'Contractual Obligations: ', text: 'These are the requirements specified in agreements with clients, vendors, or other stakeholders.' }
                        ]
                    },
                    {
                        type: 'paragraph',
                        text: 'In simpler terms, the compliance module in a GRC application helps organizations:'
                    },
                    {
                        type: 'list',
                        format: 'unordered',
                        items: [
                            { text: 'Stay up-to-date with relevant rules.' },
                            { text: 'Make sure they are following those rules.' },
                            { text: 'Prove that they are following those rules.' },
                            { text: 'Reduce the risk of penalties or legal issues.' }
                        ]
                    }
                ]
            },
            {
                title: 'How do I access the Compliance Setup section?',
                type: 'rich_text',
                content: [
                    {
                        type: 'list',
                        format: 'unordered',
                        items: [
                            { text: 'To access the Compliance Setup section, navigate to the main menu' },
                            { text: "Click on the 'Compliance' module. Once the module is selected, you'll see a dropdown" },
                            { text: "Click on the 'Compliance Setup' sub-section to proceed." }
                        ]
                    }
                ]
            },
            {
                title: 'What are the initial steps for setting up a new compliance regulation?',
                type: 'rich_text',
                content: [
                    {
                        type: 'paragraph',
                        text: 'To set up a new compliance regulation, follow these steps:'
                    },
                    {
                        type: 'list',
                        format: 'unordered',
                        items: [
                            { text: "Navigate to the 'Compliance Setup' sub-section." },
                            { text: 'Select the regulatory body and add the desired regulation.' },
                            { text: "Click on the regulatory body's name to add the compliance list." },
                            { text: "On the new page, click 'Add Compliance." },
                            { text: "Complete the displayed form with the compliance details and click 'Save.'" }
                        ]
                    }
                ]
            },
            {
                title: 'How do I access the Compliance Calendar View?',
                type: 'rich_text',
                content: [
                    {
                        type: 'paragraph',
                        text: "The Compliance Calendar View can be accessed by selecting 'Manage Compliance' from the 'Compliance' main menu. This will present a calendar format displaying all compliances scheduled for each day."
                    }
                ]
            },
            {
                title: 'How to Edit Compliance due date?',
                type: 'rich_text',
                content: [
                    {
                        type: 'paragraph',
                        text: 'To edit the due date for a compliance when the regulatory body extends the filing deadline:'
                    },
                    {
                        type: 'list',
                        format: 'ordered',
                        items: [
                            { text: "Navigate to the 'Manage Compliance' sub-section within the 'Compliance' module." },
                            { text: 'Select the compliance for which you need to change the due date.' },
                            { text: 'Open the compliance details.' },
                            { text: "Click the 'Edit' icon next to the 'Due By' field." },
                            { text: "Enter the revised due date in the 'Due By' field." },
                            { text: 'Add remarks and any relevant attachments for future reference.' },
                            { text: "Click 'Save' to update the compliance due date." }
                        ]
                    }
                ]
            },
            {
                title: 'How do I inactivate a compliance regulation?',
                type: 'rich_text',
                content: [
                    {
                        type: 'paragraph',
                        text: 'To inactivate a compliance regulation that is no longer applicable due to regulatory changes:'
                    },
                    {
                        type: 'list',
                        format: 'ordered',
                        items: [
                            { text: "Use the 'Edit Compliance' function." },
                            { text: "Change the status of the compliance from 'Active' to 'Inactive.'" },
                            { text: 'Enter the inactivation date.' }
                        ]
                    }
                ]
            },
            {
                title: 'What is the effective date, and how is it used?',
                type: 'rich_text',
                content: [
                    {
                        type: 'paragraph',
                        text: 'The Effective Date field designates the starting date for an active compliance regulation. When inactivating a regulation, the Effective Date is used to define the date from which the regulation is no longer considered in effect.'
                    }
                ]
            },
            {
                title: 'Where can we see the overdue compliance?',
                type: 'rich_text',
                content: [
                    {
                        type: 'paragraph',
                        text: 'To view overdue compliances:'
                    },
                    {
                        type: 'list',
                        format: 'ordered',
                        items: [
                            { text: 'Navigate to the calendar view for the desired month.' },
                            { text: 'Overdue compliances for that month will be displayed within the calendar dates.' },
                            { text: 'For a complete list of all overdue and incomplete compliances, look at the top right corner of the calendar.' },
                            { text: "This area, labeled 'Tasks Overdue Till Now,' provides a comprehensive list of all outstanding overdue compliances." }
                        ]
                    }
                ]
            },
            {
                title: 'What is Reassign compliance and how to use this feature?',
                type: 'rich_text',
                content: [
                    {
                        type: 'paragraph',
                        text: 'The system offers two types of compliance reassignment:'
                    },
                    {
                        type: 'heading',
                        level: 3,
                        text: '1. Permanent Reassignment (Transfer compliance):'
                    },
                    {
                        type: 'list',
                        format: 'unordered',
                        items: [
                            { text: 'This is used when an employee retires, resigns, or permanently transitions to another role, necessitating a permanent transfer of compliance responsibilities.' },
                            { text: 'To permanently transfer a compliance task:' },
                            {
                                sub_items: [
                                    { title: 'Access Transfer Compliance:', text: "Click the 'Transfer Compliance' sub-menu within the 'Compliance' main menu." },
                                    { title: 'Select Transfer From:', text: "Choose the 'Role,' 'Department Name,' and 'Person Name' of the current assignee. This will display the list of compliances assigned to them." },
                                    { title: 'Select Compliance(s):', text: 'Select the compliance task(s) you want to transfer. You can select single or multiple tasks by checking the box next to the compliance name.' },
                                    { title: 'Select Transfer To:', text: "Choose the 'Role,' 'Department Name,' and 'Person Name' of the new assignee." },
                                    { title: 'Add Remarks:', text: 'Enter any relevant remarks for the transfer.' },
                                    { title: 'Apply Transfer:', text: "Click the 'Apply' button. The compliance task(s) will be permanently transferred." }
                                ]
                            }
                        ]
                    },
                    {
                        type: 'heading',
                        level: 3,
                        text: '2. Temporary Reassignment:'
                    },
                    {
                        type: 'list',
                        format: 'unordered',
                        items: [
                            { text: 'This option is used when an employee is on extended leave or experiencing a temporary overload. It allows for the temporary delegation of compliance tasks for a defined period.' },
                            { text: 'To Temporary reassign a compliance task:' },
                            {
                                sub_items: [
                                    { title: 'Access the Reassign Compliance Feature:', text: "Click on the 'Reassign Compliance' label in the Compliance Calendar View." },
                                    { title: 'Set the Date Range:', text: "Select the 'From Date' and 'To Date' to filter the compliance tasks." },
                                    { title: 'Select Compliance(s):', text: 'Choose the compliance task(s) you wish to reassign. You can select single or multiple tasks by checking the box on the left side of the compliance name.' },
                                    { title: ' Apply Filter:', text: "Click 'Apply' to display the selected compliance tasks." },
                                    { title: 'Choose Reassign:', text: "Select the 'Department,' 'Role,' and 'User Name' to whom you want to reassign the compliance task(s). Note: Reassignment is limited to users within the same department." },
                                    { title: 'Reassign:', text: "Click the 'Reassign' button." },
                                    { title: 'Notification and Acknowledgement:', text: 'The new assignee will receive a notification and must acknowledge the reassignment' }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        module: 'Calendar',
        topics: [
            {
                title: 'Calendar',
                type: 'paragraph',
                content: [{ type: 'paragraph', text: 'A module that displays Compliance deadlines and Event filters.' }]
            }
        ]
    },
    {
        module: 'Tools',
        topics: [
            {
                title: 'Tools',
                type: 'paragraph',
                content: [{ type: 'paragraph', text: 'Software modules used for brainstorming sessions and workouts.' }]
            }]
    },
    {
        module: 'Settings',
        topics: [
            { title: 'History', type: 'paragraph', content: [{ type: 'paragraph', text: 'A record of past actions and decisions related to governance, risk, or compliance.' }] }
        ]
    }
]
